import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-group-item',
  templateUrl: './group-item.component.html',
  styleUrls: ['./group-item.component.css']
})
export class GroupItemComponent implements OnInit {
  isNotExist = true;
  @Output() seeAlls = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  show(items: any[], type) {
    if (items.length) {
      this.isNotExist = false;
      document.getElementById(type).style.display = 'block';
    }
  }
  seeAll(type) {
    this.seeAlls.emit(type)
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/list-item/group-item/group-item.component.ts